
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AdminDashboard from "./AdminDashboard";
import PendingPromptsTab from "./PendingPromptsTab";
import UsersTab from "./UsersTab";
import ResourcesTab from "./ResourcesTab";
import ReportsTab from "./ReportsTab";
import CategoryManager from "./CategoryManager";
import { Badge } from "@/components/ui/badge";

interface AdminTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  pendingPrompts: any[];
  isLoadingPrompts: boolean;
  handleApprove: (id: string) => Promise<void>;
  handleReject: (id: string) => Promise<void>;
  handleDelete: (id: string) => Promise<void>;
  users: any[];
  isLoadingUsers: boolean;
  fetchUsers: () => Promise<void>;
  totalCategories: number;
  reportedIssues: number;
}

const AdminTabs: React.FC<AdminTabsProps> = ({
  activeTab,
  setActiveTab,
  pendingPrompts,
  isLoadingPrompts,
  handleApprove,
  handleReject,
  handleDelete,
  users,
  isLoadingUsers,
  fetchUsers,
  totalCategories,
  reportedIssues,
}) => {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="grid w-full grid-cols-6">
        <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
        <TabsTrigger value="pending" className="relative">
          Pending Prompts
          {pendingPrompts.length > 0 && (
            <Badge variant="destructive" className="ml-2 h-5 w-5 p-0 text-xs">
              {pendingPrompts.length}
            </Badge>
          )}
        </TabsTrigger>
        <TabsTrigger value="users">Users</TabsTrigger>
        <TabsTrigger value="categories">Categories</TabsTrigger>
        <TabsTrigger value="resources">Resources</TabsTrigger>
        <TabsTrigger value="reports">Reports</TabsTrigger>
      </TabsList>

      <TabsContent value="dashboard" className="mt-6">
        <AdminDashboard />
      </TabsContent>

      <TabsContent value="pending" className="mt-6">
        <PendingPromptsTab
          pendingPrompts={pendingPrompts}
          isLoading={isLoadingPrompts}
          handleApprove={handleApprove}
          handleReject={handleReject}
          handleDelete={handleDelete}
        />
      </TabsContent>

      <TabsContent value="users" className="mt-6">
        <UsersTab
          users={users}
          isLoadingUsers={isLoadingUsers}
          fetchUsers={fetchUsers}
        />
      </TabsContent>

      <TabsContent value="categories" className="mt-6">
        <CategoryManager />
      </TabsContent>

      <TabsContent value="resources" className="mt-6">
        <ResourcesTab />
      </TabsContent>

      <TabsContent value="reports" className="mt-6">
        <ReportsTab />
      </TabsContent>
    </Tabs>
  );
};

export default AdminTabs;
